<h2 mat-dialog-title>Matboard Options</h2>

<mat-dialog-content>

  <mbnm-filters [productData]="productData" [options]="options"
                (filterChanged)="availableProductsChanged($event)">

  </mbnm-filters>

</mat-dialog-content>
<mat-dialog-actions class="fx-layout-row fx-align--space-between-x">
  <button mat-flat-button color="primary" [mat-dialog-close]="filteredProducts">Apply</button>
  <button mat-flat-button color="secondary" mat-dialog-close>Cancel</button>
</mat-dialog-actions>
